let lockCount = 0;
let previousOverflow = '';
let previousPaddingRight = '';

/**
 * Width the page's vertical scrollbar occupies — 0 when the page doesn't
 * scroll, or when the platform uses overlay scrollbars that take no space.
 */
const getScrollbarWidth = () => {
  const root = document.documentElement;
  if (root.scrollHeight <= root.clientHeight) return 0;
  return Math.max(0, window.innerWidth - root.clientWidth);
};

/**
 * `<dialog>.showModal()` makes the rest of the document inert and traps focus,
 * but the page behind the backdrop still scrolls. Locking the body closes that
 * gap. Counted, so nested/stacked dialogs only release the lock once the last
 * one closes.
 */
export const lockBodyScroll = () => {
  lockCount += 1;
  if (lockCount > 1) return;

  const scrollbarWidth = getScrollbarWidth();
  previousOverflow = document.body.style.overflow;
  previousPaddingRight = document.body.style.paddingRight;
  document.body.style.overflow = 'hidden';

  // Hiding the scrollbar reclaims its width, shifting the page underneath the
  // backdrop. Padding the gap back keeps the layout still.
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
};

export const unlockBodyScroll = () => {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount > 0) return;

  document.body.style.overflow = previousOverflow;
  document.body.style.paddingRight = previousPaddingRight;
  previousOverflow = '';
  previousPaddingRight = '';
};
